import { NavItem as Root } from './NavItem'
import { Emoji } from './Emoji/Emoji'
import { Label } from './Label/Label'
import { ControlGroup } from './ControlGroup/ControlGroup'
import { Control } from './Control/Control'
import { Counter } from './Counter/Counter'

export const NavItem = {
  Root,
  Emoji,
  Label,
  Counter,
  ControlGroup,
  Control,
}
